import {Virtuoso} from 'react-virtuoso'
import styled, {css} from 'styled-components'

export const StyledAccessRateCard = styled.div(
    ({theme: {palette}}) => css`
        width: 100%;
        border-radius: 6px;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledAccessRateCardHeader = styled.div<{$isEditMode?: boolean}>(
    ({theme: {spacing, palette}, $isEditMode}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${spacing * 3.5}px ${spacing * 3}px;
        background-color: ${$isEditMode ? 'transparent' : palette.neutral[50]};
        border-radius: 6px 6px 0 0;
    `
)

export const StyledAccessRateCardBody = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px;
    `
)

export const StyledList: typeof Virtuoso = styled(Virtuoso)(
    ({theme: {spacing}}) => css`
        height: 300px !important;
        & > div {
            padding: ${spacing * 3}px;

            & .list-item {
                margin: ${spacing * 1.5}px 0;
                &:first-child {
                    margin-top: 0;
                }
                &:last-child {
                    padding-bottom: ${spacing * 3}px;
                }
            }
        }
    `
)

export const StyledAccessRateRow = styled.div<{$isFirst: boolean}>(
    ({theme: {spacing, palette}, $isFirst}) => css`
        display: grid;
        grid-template-columns: 2fr 2fr 2fr 1fr;
        align-items: center;
        gap: ${spacing * 2}px;
        background-color: ${$isFirst ? 'transparent' : palette.neutral[50]};
        padding: ${spacing * 2}px ${spacing * 4}px;
        border-radius: 6px;
        & > button {
            justify-self: end;
        }
    `
)

export const StyledAccessRateFormRows = styled.div(
    ({theme: {spacing}}) => css`
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: ${spacing * 4}px;
        column-gap: ${spacing * 3}px;
    `
)
